import { SUPABASE_CONFIG } from './supabase';

export const ENV = {
  MODE: import.meta.env.MODE,
  SUPABASE_URL: SUPABASE_CONFIG.URL,
  SUPABASE_ANON_KEY: SUPABASE_CONFIG.ANON_KEY,
  PUBLIC_R2_URL: 'https://pub-XXXX.r2.dev' // Replace with your actual R2 URL
} as const;

// Type guard for environment
export function isValidEnv(): boolean {
  return Boolean(
    ENV.SUPABASE_URL &&
    ENV.SUPABASE_ANON_KEY
  );
}

// Validate environment
if (!isValidEnv()) {
  throw new Error('Invalid configuration. Please check your configuration files.');
}